var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg013HealthCheck = function Svg013HealthCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 90c16.569 0 30-13.431 30-30h30V0H196v60h30c0 16.569 13.431 30 30 30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 30v482h330V30h-75v60h-38.057c-10.386 17.915-29.78 30-51.943 30s-41.558-12.085-51.943-30H166V30zm240 421H151v-30h180zm30-60H151v-30h210zM211 211h30v-30h30v30h30v30h-30v30h-30v-30h-30zm150 90v30H151v-30z"
  })));
};
export default Svg013HealthCheck;